export default __webpack_public_path__ + "static/media/logo.53e77f84.svg";